<script setup lang="ts">
import { onMounted, ref } from "vue";
import CrewCollapsible from "@/components/CrewCollapsible/CrewCollapsible.vue";
import { CrewMember } from "@/models/CrewMember";
import { getTripCrew } from "@/services/trip.service";
import CustomButton from "@/components/Button/Button.vue";
import CustomModal from "@/components/CustomModal/CustomModal.vue";

import InviteCrewMemberModal from "@/components/InviteCrewMemberModal/InviteCrewMemberModal.vue";
import ManuallyAddCrewMemberModal from "@/components/ManuallyAddCrewMemberModal/ManuallyAddCrewMemberModal.vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  tripId: string;
}>();

const showInviteCrewMemberModal = ref(false);
const showInviteCrewMemberListModal = ref(false);
const manuallyAddCrewMemberModal = ref(false);
const showSendInviteModal = ref(false);

const crew = ref<CrewMember[]>([]);

const { t } = useI18n(); // Use the i18n instance

onMounted(() => {
  getTripCrew(props.tripId).then((response) => (crew.value = response.data));
});
</script>

<template>
  <div class="container flex flex-col gap-4">
    <div v-for="member in crew" :key="member.uuid">
      <CrewCollapsible :member="member" />
    </div>
    <div class="mobile">
      <CustomButton type="black" class=" responsive-body-medium w-fit h-8 btnText" :rounded="true"
        @click="showInviteCrewMemberModal = true">{{ t('crewActions.add') }}
      </CustomButton>
      <CustomModal :show="showInviteCrewMemberModal" :title="t('crewActions.inviteCrewMember')"
        :mobile-fullscreen="false" @on-close="showInviteCrewMemberModal = false" extra-classes="h-fit"
        drawerHeight="fit-content">
        <div>
          <div>
            <div class="mt-5 w-52">
              <div class="cursor-pointer"
                @click="showInviteCrewMemberListModal = true; showInviteCrewMemberModal = false">
                <div>{{ t('crewActions.selectFromList') }}</div>
              </div>
              <div class="cursor-pointer" @click="showSendInviteModal = true; showInviteCrewMemberModal = false">
                <div>{{ t('crewActions.sendInvite') }}</div>
              </div>
              <div class="cursor-pointer" @click="manuallyAddCrewMemberModal = true; showInviteCrewMemberModal = false">
                <div>{{ t('crewActions.addManually') }}</div>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
      <InviteCrewMemberModal @on-close="showInviteCrewMemberListModal = false" :open="showInviteCrewMemberListModal" />
      <ManuallyAddCrewMemberModal :open="manuallyAddCrewMemberModal" @on-close="manuallyAddCrewMemberModal = false" />
    </div>
  </div>
</template>

<style scoped>
  .mobile {
    display: none;
  }
  @media (max-width: 768px) {
    .mobile {
      display: block;
    }
    .desktop {
      display: none;
    }
    div.modal.rounded-t-12xl.el-drawer.btt.open{
      height: unset;
    }
  }
</style>
